const P = {
  silver: '#F1F5F9',
  white: '#FFFFFF',
  grid: '#E2E8F0',
  border: '#CBD5E1',
  shimmer: '#E2E8F0',
};

function Bone({ className = '', style = {} }) {
  return (
    <div
      className={`animate-pulse rounded-lg ${className}`}
      style={{ backgroundColor: P.shimmer, ...style }}
      aria-hidden="true"
    />
  );
}

export default function PayrollSkeleton() {
  return (
    <div
      className="min-h-full rounded-2xl border p-6 font-sans sm:p-8"
      style={{
        backgroundColor: P.silver,
        borderColor: P.grid,
        color: '#1E293B',
      }}
      role="status"
      aria-live="polite"
      aria-label="Loading payroll data"
    >
      <div
        className="mb-8 flex flex-col gap-4 border-b-2 pb-6 md:flex-row md:items-center md:justify-between"
        style={{ borderColor: P.border }}
      >
        <div className="space-y-3">
          <Bone className="h-6 w-48" />
          <Bone className="h-9 w-72 max-w-full" />
          <Bone className="h-4 w-56" />
        </div>
        <Bone
          className="h-14 w-full max-w-xs rounded-xl"
          style={{ backgroundColor: P.white, boxShadow: '0 1px 2px rgb(15 23 42 / 0.05)' }}
        />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <section
          className="space-y-3 rounded-2xl border p-6 lg:col-span-2"
          style={{ backgroundColor: P.white, borderColor: P.grid }}
        >
          <div className="mb-2 flex items-center gap-3 border-b pb-4" style={{ borderColor: P.grid }}>
            <Bone className="h-9 w-9 rounded-lg" />
            <div className="flex-1 space-y-2">
              <Bone className="h-5 w-52" />
              <Bone className="h-3 w-36" />
            </div>
          </div>
          {[1, 2, 3, 4].map((row) => (
            <Bone
              key={row}
              className="h-[72px] w-full rounded-xl"
              style={{ backgroundColor: P.silver }}
            />
          ))}
        </section>

        <aside
          className="rounded-2xl border p-6"
          style={{ backgroundColor: P.white, borderColor: P.grid }}
        >
          <Bone className="mb-6 h-5 w-36" />
          <Bone
            className="mx-auto h-36 w-full rounded-2xl border-2 border-dashed"
            style={{ backgroundColor: P.silver, borderColor: P.border }}
          />
          <div className="mt-6 space-y-3">
            <Bone className="h-4 w-full" />
            <Bone className="h-4 w-full" />
          </div>
          <Bone className="mt-8 h-14 w-full rounded-xl" style={{ backgroundColor: '#93C5FD' }} />
        </aside>
      </div>

      <p className="mt-6 text-center text-xs font-semibold uppercase tracking-widest text-[#64748B]">
        Syncing dispatch payroll ledger…
      </p>
    </div>
  );
}
